<template>
  <button class="qm-button" :class="computedClass" @click="bindClick">
    <i v-if="loading" class="qm-button-loading-mask">
      <img src="/static/icon/icon-button-loading.svg" alt />
    </i>
    <img v-if="icon" :class="`${icon}`" :src="iconUrl" alt />
    <span v-if="text" :class="{both: icon && text}">{{ text }}</span>
    <i v-if="canDrop" class="drop" />
  </button>
</template>

<script>
export default {
  name: 'QmButton',
  props: {
    type: {
      type: String,
      default: 'confirm',
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    canDrop: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'normal',
    },
  },
  computed: {
    iconUrl() {
      return `/static/icon/icon-${this.icon}.svg`
    },
    buttonType() {
      // values: ['icon', 'text', 'mix']
      if (this.text && !this.icon) {
        return 'text'
      } else if (!this.text && this.icon) {
        return 'icon'
      } else if (this.text && this.icon) {
        return 'mix'
      } else {
        return ''
      }
    },
    computedClass() {
      return [
        this.type,
        {
          disabled: this.disabled,
          selected: this.selected,
          text: this.text && !this.icon,
          icon: this.icon && !this.text,
          mix: this.text && this.icon,
          [`size-${this.size}`]: this.size,
        },
      ]
    },
  },
  methods: {
    bindClick() {
      if (this.disabled) {
        // console.log('禁用')
      } else {
        this.$emit('click')
      }
    },
  },
}
</script>

<style lang="scss">
.qm-button.deputy {
  color: #333;
  background: rgba(238, 238, 238, 1);
  box-shadow: 0 3px 2px -2px rgba(0, 0, 0, 0.16);
  border: 1px solid #333;
  min-width: 36px;
}

.qm-button.empty {
  border: 1px solid #000;
  background: transparent;
  font-size: 14px;
  color: #333333;
  letter-spacing: 0;

  &.disabled {
    color: rgba(#333333, 0.4);
    background: transparent;
    border: 1px solid rgba(#000000, 0.4);
    border-radius: 2px;
  }
}
</style>
